import React from 'react';
import { UsersIcon, AwardIcon, BookOpenIcon, HeartIcon, TrendingUpIcon } from 'lucide-react';
export function KeyBenefitsSection() {
  return <section id="key-benefits" className="py-20 bg-gradient-to-br from-purple-600 to-blue-600 text-white relative overflow-hidden" data-id="element-198">
      {/* Geometric shapes */}
      <div className="absolute top-0 left-0 w-40 h-40 bg-white opacity-5 rounded-br-full" data-id="element-199"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-white opacity-5 rounded-tl-full" data-id="element-200"></div>
      <div className="absolute top-1/2 left-1/4 w-20 h-20 bg-white opacity-5 rotate-45 animate-spin" style={{
      animationDuration: '15s'
    }} data-id="element-201"></div>
      <div className="absolute bottom-1/3 right-1/4 w-16 h-16 bg-white opacity-5 rounded-full animate-ping" style={{
      animationDuration: '10s'
    }} data-id="element-202"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-203">
        <div className="text-center mb-12" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-205">
            ❤️ Key Benefits to Your School
          </h2>
          <div className="w-24 h-1 bg-white/40 mx-auto" data-id="element-206"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-207">
          {/* Benefit Card 1 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10" data-id="element-208">
            <div className="flex items-center mb-4" data-id="element-209">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-210">
                <UsersIcon className="w-5 h-5 text-white" data-id="element-211" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-212">Full Access to Eedi Plus</h3>
            </div>
            <p className="text-white/90" data-id="element-213">
              Full Eedi Plus access for all teachers and students, including
              1-to-1 tutor support and personalized learning tools.
            </p>
          </div>
          {/* Benefit Card 2 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10" data-id="element-214">
            <div className="flex items-center mb-4" data-id="element-215">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-216">
                <AwardIcon className="w-5 h-5 text-white" data-id="element-217" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-218">£500 Base Award</h3>
            </div>
            <p className="text-white/90" data-id="element-219">
              Awarded for successful Eedi integration and meeting usage
              thresholds.
            </p>
          </div>
          {/* Benefit Card 3 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10" data-id="element-220">
            <div className="flex items-center mb-4" data-id="element-221">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-222">
                <BookOpenIcon className="w-5 h-5 text-white" data-id="element-223" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-224">Exclusive CPD Courses</h3>
            </div>
            <p className="text-white/90" data-id="element-225">
              Complimentary access to Craig Barton's renowned CPD courses for
              all participating teachers.
            </p>
          </div>
          {/* Benefit Card 4 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10" data-id="element-226">
            <div className="flex items-center mb-4" data-id="element-227">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-228">
                <AwardIcon className="w-5 h-5 text-white" data-id="element-229" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-230">Free STAR Maths Assessments</h3>
            </div>
            <p className="text-white/90" data-id="element-231">
              Free access to STAR maths assessments for all participating
              students (worth £££)!
            </p>
          </div>
          {/* Benefit Card 5 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10" data-id="element-232">
            <div className="flex items-center mb-4" data-id="element-233">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-234">
                <TrendingUpIcon className="w-5 h-5 text-white" data-id="element-235" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-236">Additional Rewards</h3>
            </div>
            <p className="text-white/90" data-id="element-237">
              Financial rewards for R&D pilots, user research, and valuable
              feedback.
            </p>
          </div>
          {/* Benefit Card 6 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 hover:bg-white/20 transition-colors transform hover:scale-105 duration-300 border border-white/10" data-id="element-238">
            <div className="flex items-center mb-4" data-id="element-239">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-240">
                <HeartIcon className="w-5 h-5 text-white" data-id="element-241" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-242">Dedicated Support</h3>
            </div>
            <p className="text-white/90" data-id="element-243">
              Hands-on support from Eedi's technical and research teams to
              maximize platform utilization.
            </p>
          </div>
        </div>
      </div>
    </section>;
}